import React from 'react';
import "./success.css";
import Button from '../../../Elements/Button/Button';
import { useNavigate } from 'react-router-dom';

const Success = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/"); // Redirige al inicio
  };

  return (
    <div className="container-fluid success-container d-flex justify-content-center align-items-center">
      <div className="success-card text-center">
        <div className="success-icon">✓</div>
        <h1 className="success-title">¡Pago Exitoso!</h1>
        <p className="success-message">
          Tu transacción se ha realizado correctamente 🎉
        </p>

        {/* Usamos tu Button reutilizable */}
        <Button
          text="Volver al inicio"
          action={handleGoHome}
          color="purple"
          fill={true}
          classNames="mt-3"
        />
      </div>
    </div>
  );
}

export default Success;